export const csvData = `
channel,activity,ad_format,activating,impacting,building,reinforcing
TV,Amazon,,1,1,1,1
TV,Branded Content (Core: TV),,0,0,1,1
TV,DRTV,,1,1,0,1
TV,Programme Integration (Package),,0,0,1,1
TV,Sponsorship,,0,0,1,1
TV,,,0,1,1,1
Social media,Douyin (TikTok),,1,1,1,1
Social media,Facebook,Video,1,1,1,0
Social media,Influencer,,1,1,1,1
Social media,Social (ER 10+),,1,1,1,1
Social media,Twitch,,1,1,1,1
Social media,,,1,1,0,1
Search,,,1,0,0,0
Print,Aggregate,,1,1,0,1
Print,Businessweek,,1,0,0,0
Print,Caijing,,1,0,0,0
Print,CBN yicai,,1,0,0,0
Print,Consumer magazines,,1,1,0,1
Print,Digital News Properties,,1,0,0,1
Print,Digital print media,,1,0,0,1
Print,Direct Mail,,1,1,0,0
Print,Door Drops,,1,0,0,0
Print,Inserts,,1,0,0,0
Print,Lidl,,1,0,0,0
Print,Newspapers,Supplements,1,1,1,1
Print,OCG,,1,0,1,0
Print,PQG,,1,0,1,0
Print,PQN,,1,0,1,0
Print,PQR,,1,0,1,0
Print,Print + Digital Combined,,1,0,1,0
Print,Trade press,,1,0,0,0
Print,Weeklies,,1,0,1,0
Print,,,1,0,1,1
Outdoor,36M (ER 5+),,0,1,1,1
Outdoor,Airport,,0,1,1,1
Outdoor,Billboard,,0,1,1,1
Outdoor,Brand Activation & Event,,0,1,1,1
Outdoor,Brand Collaboration & Cross Over,,0,1,1,1
Outdoor,Infoscreen,,1,1,0,1
Outdoor,Large Format,,0,1,1,1
Outdoor,Large Format/Billboard,,0,1,1,1
Outdoor,Lift Poster,,1,1,0,1
Outdoor,Office,,0,1,1,1
Outdoor,Office LCD,,0,1,1,1
Outdoor,Outdoor,,0,1,1,1
Outdoor,Programmatic OOH,,0,1,1,1
Outdoor,Public Transport,,0,1,1,1
Outdoor,Railway,,0,1,1,1
Outdoor,Retail,,0,1,1,1
Outdoor,Roadside,,0,1,1,1
Outdoor,Russia 100+ | BB,,0,1,1,1
Outdoor,Sporting venues,,0,1,1,1
Outdoor,"Sporting Venues, Stadiums And Arenas",,0,1,1,1
Outdoor,Street Furniture,,0,1,1,1
Outdoor,,,0,1,0,1
Digital video,DV360,,1,1,0,1
Digital video,Programmatic,,1,1,0,1
Digital video,Twitch,,1,1,1,1
Digital video,Yahoo,,1,1,0,1
Digital video,Youku,,1,1,1,1
Digital video,YouTube,Trueview in display,1,1,0,1
Digital video,YouTube,,1,1,1,1
Digital video,,,0,1,1,1
Digital display,,,1,0,0,1
Cinema,,,0,1,1,1
Audio,National network,,1,1,1,1
Audio,Radio Ads,,1,1,1,1
Audio,Regional network,,1,1,1,1
Audio,Total 'Linear' radio,,1,1,1,1
Audio,,,0,1,1,1
Affiliates,,,1,0,0,0
`;
